import React from "react";
import { CompanyUsersList } from "../../company/users/list";

/**
 * HR → Employees: same Users list/API, scoped to users with an active
 * employment (`Employee`) row in the current company.
 */
export const HrEmployeesList = () => <CompanyUsersList employeesOnly />;
